import script from "./PaymentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentForm.vue?vue&type=script&setup=true&lang=js"

import "./PaymentForm.vue?vue&type=style&index=0&id=3ac850be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ac850be"]])

export default __exports__